import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import { labels } from "../../../../localization/labels";
import ElasticSearchService from "../../../../services/ElasticSearchService";
import { falseFilter, trueFilter } from "../../../../services/FilteringUtils";
import KnowledgeService from "../../../../services/KnowledgeService";
import CommonUtil from "../../../../utils/CommonUtil";
import PageComponent from "../../page/PageComponent";
import System from "./System";

class SystemContainer extends PageComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.modalInitialState,
      indexingFinished: undefined,
      withAttachmentAll: true,
      withAttachmentOne: true
    };
    this.elasticSearchService = new ElasticSearchService(this.keycloak);
    this.knowledgeService = new KnowledgeService(this.keycloak);
  }

  modalInitialState = {
    modal: {
      title: undefined,
      body: undefined,
      show: false,
      action: undefined
    }
  };

  componentDidMount() {
    super.componentDidMount();
    this.getReindexStatus();
    this.loadEntities();
    this.interval = setInterval(() => {
      this.getReindexStatus();
      this.getReindexStatusOne();
    }, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  loadEntities = () => {
    this.prepareCall(
      this.knowledgeService.getEntities(
        undefined,
        undefined,
        this.onEntitesLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onEntitesLoad = data => {
    const entities = CommonUtil.getDataContent(data);
    this.setState({ entities: entities });
  };

  setModalInitialState = () => {
    this.setState({ ...this.modalInitialState });
  };

  getComponentTitle = () => {
    return labels.system;
  };

  onStartIndexing = indexFunction => {
    this.setState({
      modal: {
        title: labels.startIndexingModalHeader,
        body: labels.startIndexingModalBody,
        show: true,
        action: () => this.startIndexing(indexFunction)
      }
    });
  };

  reindexAll = () => {
    this.prepareCall(
      this.elasticSearchService.reindexAll(
        this.createPageInfo(this.state.withAttachmentAll),
        this.onStartedIndexing,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  reindexOne = () => {
    this.prepareCall(
      this.elasticSearchService.reindexOne(
        this.state.selectedEntity,
        this.createPageInfo(this.state.withAttachmentOne),
        this.onStartedIndexingOne,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  createPageInfo = withAttachment => {
    return {
      filters: {
        withAttachment: CommonUtil.stringToBoolean(withAttachment)
          ? trueFilter
          : falseFilter
      }
    };
  };

  startIndexing = indexFunction => {
    indexFunction();
    this.setModalInitialState();
  };

  onStartedIndexing = data => {
    this.getReindexStatus();
  };

  getReindexStatus = () => {
    this.prepareCall(
      this.elasticSearchService.getReindexStatus(
        data =>
          this.onReindexStatus(data, "indexingFinished", "withAttachmentAll"),
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onReindexStatus = (data, indexFinishedKey, withAttachmentKey) => {
    if (data) {
      const withAttachment =
        data.finished ||
        data.withAttachment === null ||
        data.withAttachment === undefined
          ? this.state[withAttachmentKey]
          : data.withAttachment;
      this.setState({
        [indexFinishedKey]: data.finished,
        [withAttachmentKey]: withAttachment
      });
    }
  };

  onStartedIndexingOne = data => {
    this.getReindexStatusOne();
  };

  getReindexStatusOne = () => {
    if (this.state.selectedEntity) {
      this.prepareCall(
        this.elasticSearchService.getReindexStatusOne(
          this.state.selectedEntity,
          data =>
            this.onReindexStatus(
              data,
              "indexingFinishedOne",
              "withAttachmentOne"
            ),
          this.messageHandler.handleError
        )
      );
      this.performCalls();
    }
  };

  onChange = event => {
    const value = event?.target?.value;
    this.setState({ [event?.target?.id]: value }, () =>
      this.onChangeListener(event?.target?.id)
    );
  };

  onChangeListener = targetId => {
    if (targetId === "selectedEntity") {
      this.setState({ withAttachmentOne: true }, this.getReindexStatusOne);
    }
  };

  render() {
    return (
      <System
        onStartIndexingAll={() => this.onStartIndexing(this.reindexAll)}
        modal={this.state.modal}
        onModalClose={this.setModalInitialState}
        indexingFinished={this.state.indexingFinished}
        selectedEntity={this.state.selectedEntity}
        entities={this.state.entities}
        onChange={this.onChange}
        indexingFinishedOne={this.state.indexingFinishedOne}
        onStartIndexingOne={() => this.onStartIndexing(this.reindexOne)}
        withAttachmentAll={this.state.withAttachmentAll}
        withAttachmentOne={this.state.withAttachmentOne}
        {...this.handlerProps()}
      />
    );
  }
}

export default withKeycloak(SystemContainer);
